import * as p from '@clack/prompts'
import type { Cancellable, InstallableChoice } from '@cli-types/core-engine/commands.js'
import { CANCELLED } from '@cli-constants/commands.js'

export async function promptInstallableFamily(
  presets: InstallableChoice[],
  integrations: InstallableChoice[]
): Promise<Cancellable<'preset' | 'integration'>> {
  if (integrations.length === 0) {
    return 'preset'
  }
  if (presets.length === 0) {
    return 'integration'
  }

  const family = await p.select<'preset' | 'integration'>({
    message: 'Presets or integrations?',
    options: [
      { value: 'preset', label: 'Presets', hint: 'content presets (e.g. blog)' },
      { value: 'integration', label: 'Integrations', hint: 'services (e.g. r2, resend)' }
    ]
  })
  return p.isCancel(family) ? CANCELLED : family
}
